/** A complete ACL-filtered choice list; never use just the first catalog page. */
export async function loadLearningCourseOptions(request, currentId = 0) {
  const result = []; const seen = new Set(); let cursor = 0;
  do {
    const page = await request(`/courses?scope=available&limit=100&cursor=${cursor}`);
    if (!Array.isArray(page.items)) throw new Error('Invalid course list');
    for (const course of page.items) {
      const id = Number(course.id);
      if (!Number.isSafeInteger(id) || id < 1 || seen.has(id)) throw new Error('Invalid course cursor');
      seen.add(id);
      if (id !== Number(currentId)) result.push({ id, title: String(course.title || ''), status: course.status });
    }
    const next = page.next_cursor === null || page.next_cursor === undefined ? null : Number(page.next_cursor);
    if (next !== null && (!Number.isSafeInteger(next) || next <= cursor)) throw new Error('Invalid course cursor');
    cursor = next;
  } while (cursor !== null);
  return result;
}

export function learningCourseMetadataPayload(raw) {
  const questions = raw.getAll('faq_question'); const answers = raw.getAll('faq_answer');
  const kinds = raw.getAll('material_kind'); const titles = raw.getAll('material_title');
  const urls = raw.getAll('material_url'); const references = raw.getAll('material_reference');
  return {
    tags: [...new Set(String(raw.get('tags') || '').split(',').map(value => value.trim()).filter(Boolean))],
    faq: questions.map((question, index) => ({ question: String(question).trim(), answer: String(answers[index] || '').trim() })),
    links: kinds.map((kind, index) => ({ title: String(titles[index] || '').trim(), ...(kind === 'media' ? { reference_id: String(references[index] || '') } : { url: String(urls[index] || '').trim() }) })),
    related_course_ids: raw.getAll('related_course_ids').map(Number),
    prerequisite_course_ids: raw.getAll('prerequisite_course_ids').map(Number),
  };
}

export function learningExternalMaterialUrl(value) {
  try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password ? url.href : null; } catch (_) { return null; }
}
